<template>
  <div class="active-users">
    <span>{{$t("message.active_users", {"mins": mins}) | title}}: </span>
    <span v-if="users" :id="'active-users-' + mins">
      {{users.length ? users.length : 0}}
    </span>
    <b-tooltip v-if="users" :target="'active-users-' + mins" triggers="hover">
      <div v-for="user in users">
        {{user.user_upn}}
      </div>
    </b-tooltip>
    <span>
      <svg class="icon icon-refresh ml-2" :id="'refresh-' + mins" @click="loadActiveUsers"
        :class="{inProgress: 'disabled'}"/>
      <b-tooltip :target="'refresh-' + mins" triggers="hover">
        {{$t("message.button_refresh")}}
      </b-tooltip>
    </span>
    <span v-if="users">
      <svg class="icon icon-email ml-5" :id="'notify-' + mins" @click="notifyActiveUsers"
        :class="{inProgress: 'disabled'}"/>
      <b-tooltip :target="'notify-' + mins" triggers="hover">
        {{$t("message.button_notify")}}
      </b-tooltip>
    </span>

    <b-alert v-model="showSuccess" variant="success" dismissible @dismissed="showSuccess=false">
      {{$t('message.notify_success')}}
    </b-alert>
    <b-alert v-model="showNotifiedCount" variant="danger" dismissible @dismissed="notifyFailedCount=0; showNotifyFailed">
      {{$t('message.notified_count', {notified_count: notifiedCount})}} <br>
      {{$t('message.notify_failed_count', {failed_count: failedToNotifyCount})}}
    </b-alert>
    <b-alert v-model="showNotifyFailure" variant="danger" dismissible @dismissed="showNotifyFailure=false">
      {{$t('message.notify_failure')}}
    </b-alert>

  </div>
</template>

<script>
import {get, post} from '../http'

export default {
  name: "ActiveUsers",

  props: {
    mins: Number
  },

  data() {
    return {
      inProgress: false,
      users: null,
      failedToNotifyCount: 0,
      notifiedCount: 0,
      showNotifiedCount: false,
      showNotifyFailure: false,
      showSuccess: false}
  },

  mounted() {
    this.loadActiveUsers()
  },

  methods: {
    loadActiveUsers() {
      this.inProgress = true
      get('/active_users?mins=' + this.mins).then(
        resp => {
          this.inProgress = false
          this.users = resp.data
        },
        err => {
          this.inProgress = false
          console.log("err", err);
        }
      )
    },

    notifyActiveUsers() {
      this.inProgress = true
      this.showNotifyFailure = false
      this.showNotifiedCount = false
      this.showSuccess = false
      this.notifyFailedCount = 0
      this.notifiedCount = 0

      post('/notify_active_users?mins=' + this.mins).then(
        resp => {
          this.inProgress = false
          if (resp.data.success) {
            this.failedToNotifyCount = resp.data.failed_to_notify_count
            this.notifiedCount = resp.data.notified_count
            if (this.failedToNotifyCount > 0) {
              this.showNotifiedCount = true
            } else {
              this.showSuccess = true
            }
          } else {
            this.showNotifyFailure = true
          }
        },
        err => {
          this.inProgress = false
          this.showNotifyFailure = true
          console.log("err", err);
        }
      )
    }
  }
}
</script>
